import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {rootRoutes} from './app-root-routing.routes';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor, AuthInterceptor} from 'lib-auth';
import {AccessInterceptor} from './modules/auth/interceptors/access.interceptor';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';

@NgModule({
    imports: [RouterModule.forRoot(rootRoutes, {anchorScrolling: 'enabled'})],
    exports: [RouterModule],
    providers: [
        provideCharts(withDefaultRegisterables()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AccessInterceptor,
            multi: true
        }
    ]
})
export class AppRootRoutingModule {
}
